import ModalForm from './ModalForm'
import ModalFormContainer from './ModalFormContainer'

export { ModalForm }
export default ModalFormContainer
